import { render, staticRenderFns } from "./ModalShipmentDetail.vue?vue&type=template&id=5904e26e&lang=pug&"
import script from "./ModalShipmentDetail.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalShipmentDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports